import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import { getSandboxPrompts } from '@/services/sandboxPromptsService';

export const useSandboxPromptsListQuery = () => {
	const { toast } = useToast();

	return useQuery({
		queryKey: ['sandbox-prompt-query'],
		queryFn: getSandboxPrompts,
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact the support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});
		}
	});
};
